import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FieldRow, FormFooter, Title } from '@xsolla/ui-core';
import { SuccessColorful } from '@xsolla/ui-icons';
import { ModalAlert } from '@xsolla/ui-modal';

type Props = {
  onClose: () => void;
};

const ExportSuccessModal = ({ onClose }: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <ModalAlert
      footer={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <FormFooter>
          <FieldRow justify="center" stretched>
            <Button look="tertiary" palette="muted" onClick={onClose}>
              {intl.formatMessage({ id: 'button.close' })}
            </Button>
          </FieldRow>
        </FormFooter>
      }>
      <>
        <SuccessColorful size={40} />
        <Title center indent="sm">
          {intl.formatMessage({ id: 'users.export.success.label' })}
        </Title>
        <p>{intl.formatMessage({ id: 'users.export.success.sublabel' })}</p>
      </>
    </ModalAlert>
  );
};

export default ExportSuccessModal;
